import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { oktaAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageProps } from '@backstage/core-plugin-api';
import { adminAuthApiRef } from '../apis';

type SignInProvider = {
  id: string;
  title: string;
  message: string;
  apiRef: typeof oktaAuthApiRef | typeof adminAuthApiRef;
};

export type SignInConfig = {
  providers: Array<'guest' | SignInProvider>;
  auto: boolean;
};

/**
 * Computes the sign-in providers and auto sign-in flag.
 *
 * Okta is always offered. Guest and admin providers are only available in
 * development and test. Auto sign-in is disabled in test and under Playwright
 * (E2E) so the sign-in page is actually rendered for those runs.
 */
export function buildSignInConfig(): SignInConfig {
  const providers: Array<'guest' | SignInProvider> = [
    {
      id: 'okta-auth-provider',
      title: 'Okta',
      message: 'Sign in using Okta',
      apiRef: oktaAuthApiRef,
    },
  ];

  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    providers.push('guest');
    providers.push({
      id: 'admin',
      title: 'Admin',
      message: 'Sign in as Admin User',
      apiRef: adminAuthApiRef,
    });
  }

  const isPlaywright =
    typeof window !== 'undefined' &&
    window.navigator.userAgent.includes('Playwright');
  const auto = process.env.NODE_ENV !== 'test' && !isPlaywright;

  return { providers, auto };
}

export function CustomSignInPage(props: SignInPageProps) {
  const { providers, auto } = buildSignInConfig();
  return <SignInPage {...props} auto={auto} providers={providers} />;
}

export const signInPageExtension = SignInPageBlueprint.make({
  params: {
    loader: async () => CustomSignInPage,
  },
});
